import { render, staticRenderFns } from "./companySetup.vue?vue&type=template&id=46a69a80&"
import script from "./companySetup.vue?vue&type=script&lang=js&"
export * from "./companySetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports